import { render, staticRenderFns } from "./ModDetailTabs.vue?vue&type=template&id=d3fe1aa2"
import script from "./ModDetailTabs.vue?vue&type=script&lang=js"
export * from "./ModDetailTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports